import React from 'react';
import PropTypes from 'prop-types';

function Logo({ fill }) {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 276 44"
      // version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      // xmlnslink="http://www.w3.org/1999/xlink"
      xmlSpace="preserve"
      style={{
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        strokeLinejoin: 'round',
        strokeMiterlimit: 1.41421
      }}
    >
      <g transform="matrix(1,0,0,1,-0.317697,36.0238)">
        <text
          x="0.318px"
          y="0.304px"
          style={{
            fontFamily: '"TimesNewRomanPS-BoldMT", "Times New Roman", serif',
            fontWeight: 700,
            fontSize: 45.333,
            fill
          }}
        >
          E. SASSONE
        </text>
        <text
          x="265.833px"
          y="-20.236px"
          style={{
            fontFamily: '"TimesNewRomanPS-BoldMT", "Times New Roman", serif',
            fontWeight: 700,
            fontSize: 15.547,
            fill
          }}
        >
          ®
        </text>
      </g>
    </svg>
  );
}

Logo.defaultProps = {
  fill: 'white'
};
Logo.propTypes = {
  fill: PropTypes.string
};

export default Logo;
